<template>
	 <!-- Google mapa -->
	<section class="mb-12 fade-in">
		<div ref="refMap" id="googleMap" class="bg-gray-200 rounded-xl shadow-md overflow-hidden googleMap"></div>
	</section>

	<!-- Tlačítko Zpět na výběr -->
	<section class="mb-12 fade-in text-center">
		<button class="bg-gradient-to-r from-gray-500 to-gray-600 text-white font-bold py-3 px-8 rounded-lg text-lg shadow-lg hover:from-gray-600 hover:to-gray-700 transition-all"
				@click="resetFilter">
			<svg class="w-5 h-5 inline mr-2" fill="currentColor" viewBox="0 0 24 24">
				<path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
			</svg>
			Zpět na výběr
		</button>
	</section>
</template>

<script setup lang="ts">
	import { ref, onMounted } from 'vue';
	
	const props = defineProps({
		vendors: Array
	});
	
	const refMap = ref(null);
	
	const infoWindow = new google.maps.InfoWindow({
		ariaLabel: "Prodejní místo",
	});
	
	const emit = defineEmits(['showFilter']);

	async function prepareMap(map): void {
		console.log("preparing");
		var latlngbounds = new window.google.maps.LatLngBounds();
		for (let vendor of props.vendors) {
			let location = await geocodeAddress(getAddress(vendor));
			const marker = new window.google.maps.marker.AdvancedMarkerElement({
				map: map,
				position: location,
				title: vendor.place,
				gmpClickable: true
			});
			latlngbounds.extend(marker.position);
			
			marker.addListener('click', ({ domEvent, latLng }) => {
				const { target } = domEvent;
				infoWindow.close();
				//infoWindow.setContent(marker.title);
				infoWindow.setContent(vendor.data);
				infoWindow.open(marker.map, marker);
			});
		}
		console.log("geocoding done");
		map.setCenter(latlngbounds.getCenter());
		if (props.vendors.length>1) {
			map.fitBounds(latlngbounds);
		}	
	}
		
	function geocodeAddress(address) {
		return new Promise((resolve, reject) => {
			const geocoder = new window.google.maps.Geocoder();
			geocoder.geocode({address: address}, (results, status) => {
				if (status === 'OK') {
					resolve(results[0].geometry.location);
				} else {
					reject(status);
				}    
			});    
		});
	}
		
	function getAddress(vendor): string {
		return vendor.street+","+vendor.city+","+vendor.zip;
	}
	
	function resetFilter(): void {
		emit('resetFilter');
	}

	onMounted(() => {
		const midMap = { lat: 50.073658, lng: 14.418540 };
		const map = new window.google.maps.Map(refMap.value, {
			zoom: 16,
			maxZoom: 20,
			minZoom: 10,
			center: midMap,
			disableDefaultUI: true,
			zoomControl: true,
			mapId: 'googleMap'
		});
		
		google.maps.event.addListenerOnce(map, "bounds_changed", function () {
			this.setZoom(Math.min(this.getZoom(), 16));
		});
		prepareMap(map);
	});
</script>